import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import { Icon } from 'react-icons-kit'
import { ic_add_box } from 'react-icons-kit/md/ic_add_box'
import { ic_search } from 'react-icons-kit/md/ic_search'
import { ic_delete } from 'react-icons-kit/md/ic_delete'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import NavBar from '../components/NavBar'
import FrTable from '../components/FrTable'
import FrTextInput from '../components/FrTextInput'
import FrSelect from '../components/FrSelect'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import FooterDelphus from '../components/FooterDelphus'


import api from '../services/api'
import { paramsToObject, formToObject, populateForm, objectToQueryString, isEmpty } from '../utils/functions'

import './styles/DefaultMainScreen.css';
import './styles/Manut.css';

const swal = withReactContent(Swal)

function Pacientes() {
  const [data, setData] = useState([])
  const [filter, setFilter] = useState({})
  const [filtered, setFiltered] = useState(false)
  const [comboPho, setComboPho] = useState([{ value: '', display: '' }])
  const [enableAdd, setenableAdd] = useState('N')
  const [enableEdit, setenableEdit] = useState('N')
  const [enableDel, setenableDel] = useState('N')
  const [comboSexo, setComboSexo] = useState([{ value: '', display: '' }])
  const [comboAtivo, setComboAtivo] = useState([{ value: '', display: '' }])
  const [comboUni, setComboUni] = useState([{ value: '', display: '' }])
  const [trazPreenchido, setTrazPreenchido] = useState(true)

  const columns = [
    { id: 'nome', numeric: false, label: 'Nome', align: 'left', minWidth: 300 },
    { id: 'idade', numeric: true, label: 'Idade', align: 'left', minWidth: 50 },
    { id: 'nomepho', numeric: false, label: 'Plano de Hospedagem', align: 'left', minWidth: 50 },
    { id: 'nomeuni', numeric: false, label: 'Unidade', align: 'left', minWidth: 50 },
    { id: 'pk_pac', numeric: false, label: 'Cód.Interno', align: 'left', minWidth: 30 },


  ]

  useEffect(() => {
    const fetchData = async () => {
      let tela = 'Pacientes'
      let consulta = await api.getAcessos(tela, 'Consulta')
      if (consulta !== 'S') {
        swal.fire('Usuário sem acesso', 'Usuário sem acesso a essa tela!', 'warning')
          .then((result) => {
            if (result.value) {
              window.history.back()
            }
          })
      } else {


        swal.fire({
          html: <FrLoading text="Carregando..." />,
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false
        })

        setComboPho(await api.getComboData('plano_hospedagem'))
        setComboUni(await api.getComboData('unidade'))
        setenableAdd(await api.getAcessos(tela, 'Inclusao'))
        setenableEdit(await api.getAcessos(tela, 'Alteracao'))
        setenableDel(await api.getAcessos(tela, 'Exclusao'))

        setComboSexo([
          {
            "value": "F",
            "display": "Feminino",
          },
          {
            "value": "M",
            "display": "Masculino",
          },])

        setComboAtivo([
          {
            "value": "S",
            "display": "Ativo",
          },
          {
            "value": "N",
            "display": "Inativo",
          },])




        const urlParams = new URLSearchParams(window.location.search);
        let query = paramsToObject(urlParams)

        if (trazPreenchido) {
          window.history.replaceState({ filtered: true }, 'filter', "/primavera/pacientes?ativo=S&buscar=true")
     
          let url = new URLSearchParams(window.location.search);
          query = paramsToObject(url)
          
          setFilter(query)
          populateForm(document.getElementById('searchForm'), query)

          let event = new Event('build');
          getData(event)
          setTrazPreenchido(false)
        }

        setFilter(query)
        populateForm(document.getElementById('searchForm'), query)


        swal.close()


        if (query.buscar === 'true') {
          let event = new Event('build');
          getData(event)
        }
      }
    }
    fetchData()
  }, [])

  function getData(e) {
    e.preventDefault()
    var formData = new FormData(document.getElementById('searchForm'))
    var queryObject = formToObject(formData)
    if (!isEmpty(queryObject)) {
      queryObject.buscar = true
      setFiltered(true)
      window.history.replaceState({ filtered: true }, 'filter', "/primavera/pacientes?" + objectToQueryString(queryObject));
      swal.fire({
        html: <FrLoading text="Buscando dados..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      api.get('/pacientes', { params: queryObject }).then(r => {
        setData(r.data)
        swal.close()
      })
    } else {
      swal.fire('Nenhum filtro informado!', 'Informe ao menos um filtro para realizar a busca.', 'warning')
    }
  }

  function clearForm(e) {
    e.preventDefault();
    console.log('limpa');
    window.history.replaceState({ filtered: false }, 'filter', '/primavera/pacientes');
    document.getElementById('searchForm').reset()
    setFilter({})
  }

  const handleChange = (e) => {
    const auxValues = { ...filter };
    console.log(auxValues)
    auxValues[e.target.name] = e.target.value;
    setFilter(auxValues);
  };

  return (
    <div className="Manut">
      <NavBar />
      <div className="ManutContent">
        <div className="defaultHeader">
          <h3>Residentes</h3>
          <UserOptions />
        </div>
        <br />
        <div className="filtersDiv">
          <form id="searchForm" onSubmit={getData}>
            <div>
              <FrTextInput
                value={filter.nome || ''}
                style={{ width: 330 }}
                name="nome"
                id="nome"
                color="#528b46"
                label="Nome"
                variant="outlined"
                size="small"
                onChange={handleChange}
              />
              <FrTextInput
                value={filter.cpf || ''}
                style={{ width: 130 }}
                name="cpf"
                id="cpf"
                color="#528b46"
                label="CPF"
                variant="outlined"
                size="small"
                onChange={handleChange}
              />
              <FrSelect
                value={filter.ativo || ''}
                style={{ width: 100 }}
                name="ativo"
                id="ativo"
                label='Situação'
                data={comboAtivo}
                onChange={handleChange}
              />
              <FrSelect
                value={filter.sexo || ''}
                style={{ width: 100 }}
                name="sexo"
                id="sexo"
                label='Sexo'
                data={comboSexo}
                onChange={handleChange}
              />

              <FrSelect
                value={filter.pk_pho || ''}
                style={{ width: 200 }}
                name="pk_pho"
                id="pk_pho"
                label='Plano de Hospedagem'
                data={comboPho}
                onChange={handleChange}
              />

              <FrSelect
                value={filter.pk_uni || ''}
                style={{ width: 200 }}
                name="pk_uni"
                id="pk_uni"
                label='Unidade'
                data={comboUni}
                onChange={handleChange}
              />

            </div>
            <div>
              <button onClick={getData}>
                <Icon icon={ic_search} size={18} />
                Pesquisar
              </button>
              <button onClick={clearForm}>
                <Icon icon={ic_delete} size={18} />
                Limpar
              </button>
              {enableAdd !== 'S' ? '' :
                <Link to="/primavera/pacientes/registro">
                  <button >
                    <Icon icon={ic_add_box} size={18} />
                    Novo Registro
                  </button>
                </Link>}
            </div>
          </form>
        </div>
        <br />
        <div className="tableDiv">
          <FrTable regName="pacientes" columns={columns} searched={filtered} codeName="pk_pac" page={'Pacientes'} data={data} enableEdit={enableEdit} enableDel={enableDel} />
        </div>
        <FooterDelphus />
      </div>
    </div>
  );
}

export default Pacientes;
